/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Summary of victory points gained for the given faction
 * @export
 * @interface GetFwStatsVictoryPoints
 */
export interface GetFwStatsVictoryPoints {
    /**
     * Last week's victory points gained
     * @type {number}
     * @memberof GetFwStatsVictoryPoints
     */
    lastWeek: number;
    /**
     * Total victory points gained since faction warfare began
     * @type {number}
     * @memberof GetFwStatsVictoryPoints
     */
    total: number;
    /**
     * Yesterday's victory points gained
     * @type {number}
     * @memberof GetFwStatsVictoryPoints
     */
    yesterday: number;
}

/**
 * Check if a given object implements the GetFwStatsVictoryPoints interface.
 */
export function instanceOfGetFwStatsVictoryPoints(value: object): value is GetFwStatsVictoryPoints {
    if (!('lastWeek' in value) || value['lastWeek'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('yesterday' in value) || value['yesterday'] === undefined) return false;
    return true;
}

export function GetFwStatsVictoryPointsFromJSON(json: any): GetFwStatsVictoryPoints {
    return GetFwStatsVictoryPointsFromJSONTyped(json, false);
}

export function GetFwStatsVictoryPointsFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetFwStatsVictoryPoints {
    if (json == null) {
        return json;
    }
    return {
        
        'lastWeek': json['last_week'],
        'total': json['total'],
        'yesterday': json['yesterday'],
    };
}

export function GetFwStatsVictoryPointsToJSON(json: any): GetFwStatsVictoryPoints {
    return GetFwStatsVictoryPointsToJSONTyped(json, false);
}

export function GetFwStatsVictoryPointsToJSONTyped(value?: GetFwStatsVictoryPoints | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'last_week': value['lastWeek'],
        'total': value['total'],
        'yesterday': value['yesterday'],
    };
}

